import { CancelButton } from '../../cancel-button';

export const CANCEL_BUTTON = {
  component: CancelButton,
  type: 'button',
  name: 'cancelButton',
  id: 'cancelButton',
  required: false,
  className: 'fieldMediumNoMarginBottom',
};
